module.exports = __webpack_public_path__ + "img/insurance.47c29b6.svg";